import { Checkbox, FormControlLabel, styled } from '@mui/material';
import { getResponsiveCSS } from '@utils/cssHelpers';
import CTAButton from '@components/CTAButton';
import TextArea from '@components/TextArea';

export const Wrapper = styled('div')({
  marginBottom: 50,
});

export const HeaderContainer = styled('div')({
  marginBottom: 8,
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  gap: 12,
  alignItems: 'center',
  position: 'relative',
});

export const StyledTextArea = styled(TextArea)({
  height: 180,
});

export const PostButtonContainer = styled('div')(
  getResponsiveCSS('marginTop', 10, 15),
  {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  }
);

export const SubmissionActions = styled('div')({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  '& .emojiPickerWrapper': {
    marginRight: 'auto',
  },
});

export const MeaningfulFeedbackControl = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  color: theme.palette.novotalk.$textColorDarkBlue,
  '& .MuiFormControlLabel-label': {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
}));

export const MeaningfulFeedbackCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 6,
  color: theme.palette.novotalk.$selectStandartColor,
  '&.Mui-checked': {
    color: theme.palette.novotalk.$selectEnabledColor,
  },
}));

export const StyledCTAButton = styled(CTAButton)({
  height: 36,
  minWidth: 120,
  padding: '0 16px',
});
